// leaf-town - the things that live in a codebase
(function () {
  'use strict';
  const G = window.G, T = 16, S = G.SPR, C = G.COL;

  class Enemy {
    constructor(L, x, y, w, h) {
      this.L = L; this.w = w; this.h = h; this.x = x + (T - w) / 2; this.y = y + T - h;
      this.vx = 0; this.vy = 0; this.hp = 1; this.flash = 0; this.face = -1; this.t = G.hash(x, y, 3) * 10;
      this.stompable = true; this.dmg = 1; this.kb = 1; this.loot = 1; this.col = '#fff'; this.stun = 0; this.onGround = false;
    }
    get cx() { return this.x + this.w / 2; }
    get cy() { return this.y + this.h / 2; }
    hurtboxes() { return [this]; }
    harmboxes() { return [this]; }
    hit(d, dx, dy, how) {
      const L = this.L;
      if (this.blocks && this.blocks(dx, dy, how)) return 'block';
      this.hp -= d; this.flash = 0.13; this.stun = 0.22;
      if (how !== 'stomp') { this.vx = dx * 130 * this.kb; this.vy = Math.min(this.vy, -80 * this.kb); }
      L.burst(this.cx, this.cy, 4, [this.col, '#fff'], 90, 300);
      if (this.hp <= 0) { this.die(how); return 'kill'; }
      G.audio.sfx(how === 'stomp' ? 'squish' : 'hit');
      if (this.onHurt) this.onHurt(how);
      return 'hit';
    }
    die(how) {
      const L = this.L;
      this.dead = true; L.kills++;
      L.ring(this.cx, this.cy, 2, 14, '#fff', 0.2);
      L.burst(this.cx, this.cy, 10, [this.col, '#fff', C.ink], 120, 320);
      if (how === 'stomp') for (let i = 0; i < 6; i++) L.part(this.cx + G.rand(-6, 6), this.y + this.h, G.rand(-70, 70), G.rand(-30, -5), 0.35, 2, this.col, 200);
      L.drop(this.cx, this.cy, this.loot);
      L.player.addMeter(8);
      G.audio.sfx(how === 'stomp' ? 'squish' : 'kill');
    }
    physics(dt, grav) {
      const L = this.L;
      this.vy = Math.min(this.vy + (grav === undefined ? 900 : grav) * dt, 320);
      this.hitWall = L.moveX(this, this.vx * dt);
      const hy = L.moveY(this, this.vy * dt);
      const was = this.onGround;
      this.onGround = hy > 0;
      if (hy) this.vy = 0;
      if (this.y > L.ph + 40) this.dead = true;      // fell out of the world, no reward
      return this.onGround && !was;
    }
    edgeAhead(dir) {
      const L = this.L, fx = dir > 0 ? this.x + this.w + 1 : this.x - 1, ty = Math.floor((this.y + this.h + 2) / T), tx = Math.floor(fx / T);
      return !L.solid(tx, ty) && L.tile(tx, ty) !== G.TILE.ONEWAY;
    }
    tick(dt) { this.t += dt; if (this.flash > 0) this.flash -= dt; if (this.stun > 0) this.stun -= dt; }
    spr(g, img, cx, cy, flip, sx, sy, oy) {
      if (this.flash > 0) img = G.tint(img, '#ffffff');
      G.spr(g, img, Math.round(this.x + this.w / 2) - cx, Math.round(this.y + this.h) - cy + 1 + (oy || 0), flip, sx, sy);
    }
    toPlayer() { const p = this.L.player; return { dx: p.x + 5 - this.cx, dy: p.y + 5 - this.cy, d: G.dist(this.cx, this.cy, p.x + 5, p.y + 5) }; }
  }
  G.Enemy = Enemy;

  // --- bug: walks. that's the whole bug. ---
  class Bug extends Enemy {
    constructor(L, x, y, spiky) {
      super(L, x, y, 12, 9);
      this.spiky = spiky; this.hp = spiky ? 2 : 1; this.stompable = !spiky; this.speed = spiky ? 20 : 27; this.col = spiky ? '#e0568a' : '#a9dd52';
      this.face = G.hash(x, y, 1) < 0.5 ? -1 : 1; this.loot = spiky ? 2 : 1;
    }
    update(dt) {
      this.tick(dt);
      if (this.stun <= 0) {
        if (this.onGround) { if (this.hitWall || this.edgeAhead(this.face)) this.face = -this.face; this.vx = this.face * this.speed; }
      } else if (this.onGround) this.vx *= 0.85;
      this.physics(dt);
    }
    draw(g, cx, cy) { this.spr(g, (this.spiky ? S.spiky : S.bug)[((this.t * 6) | 0) % 2], cx, cy, this.face < 0); }
  }

  // --- typo: hops at you ---
  class Typo extends Enemy {
    constructor(L, x, y) { super(L, x, y, 10, 10); this.wait = 0.4 + G.hash(x, y, 2); this.col = '#b79cff'; }
    update(dt) {
      this.tick(dt);
      if (this.onGround) {
        this.vx *= 0.7; this.wait -= dt;
        if (this.wait <= 0 && this.stun <= 0) {
          const tp = this.toPlayer();
          this.face = tp.d < 150 ? Math.sign(tp.dx) || 1 : (Math.random() < 0.5 ? -1 : 1);
          if (this.edgeAhead(this.face) && tp.d > 60) this.face = -this.face;
          this.vx = this.face * 62; this.vy = -235; this.onGround = false; this.wait = G.rand(0.55, 1);
        }
      }
      if (this.physics(dt)) this.L.dust(this.cx, this.y + this.h, 2);
      if (this.hitWall) this.vx = -this.vx * 0.5;
    }
    draw(g, cx, cy) {
      const air = !this.onGround, squat = this.onGround && this.wait < 0.18;
      this.spr(g, S.typo[air ? 1 : 0], cx, cy, this.face < 0, squat ? 1.15 : 1, squat ? 0.8 : 1);
    }
  }

  // --- flaky test: passes, passes, passes... then doesn't ---
  class Flaky extends Enemy {
    constructor(L, x, y) { super(L, x, y - 4, 10, 9); this.hx = this.x; this.hy = this.y; this.st = 'idle'; this.cd = 1; this.col = '#8fe3a0'; }
    update(dt) {
      this.tick(dt); this.cd -= dt;
      const tp = this.toPlayer();
      if (this.st === 'idle') {
        const tx = this.hx + Math.sin(this.t * 1.3) * 18, ty = this.hy + Math.sin(this.t * 2.6) * 7;
        this.x = G.damp(this.x, tx, 3, dt); this.y = G.damp(this.y, ty, 3, dt);
        this.face = Math.sign(tp.dx) || 1;
        if (tp.d < 118 && this.cd <= 0 && this.stun <= 0) { this.st = 'mad'; this.st_t = 0.5; G.audio.sfx('warn', { vol: 0.5 }); }
      } else if (this.st === 'mad') {
        this.st_t -= dt; this.x += Math.sin(this.t * 60) * 0.5;
        if (this.st_t <= 0) { const n = tp.d || 1; this.vx = (tp.dx / n) * 185; this.vy = (tp.dy / n) * 185; this.st = 'swoop'; this.st_t = 0.62; }
      } else if (this.st === 'swoop') {
        this.st_t -= dt; this.x += this.vx * dt; this.y += this.vy * dt;
        if (this.st_t <= 0 || this.L.solidAt(this.cx, this.cy)) { this.st = 'back'; }
      } else {
        const dx = this.hx - this.x, dy = this.hy - this.y, d = Math.hypot(dx, dy);
        if (d < 4) { this.st = 'idle'; this.cd = 1.4; } else { this.x += (dx / d) * 70 * dt; this.y += (dy / d) * 70 * dt; }
      }
    }
    hit(d, dx, dy, how) { const r = super.hit(d, dx, dy, how); if (r === 'hit') { this.st = 'back'; this.cd = 1; } return r; }
    draw(g, cx, cy) { this.spr(g, (this.st === 'mad' || this.st === 'swoop' ? S.flakyMad : S.flaky)[((this.t * 14) | 0) % 2], cx, cy, false, 1, 1, 2); }
  }

  // --- lint: drifting, prickly, not worth touching ---
  class Lint extends Enemy {
    constructor(L, x, y, vertical) { super(L, x, y - 2, 11, 11); this.hx = this.x; this.hy = this.y; this.v = vertical; this.hp = 2; this.stompable = false; this.col = '#b9b0d0'; this.range = 30; }
    update(dt) {
      this.tick(dt);
      const o = Math.sin(this.t * 1.6) * this.range;
      if (this.v) { this.y = this.hy + o; this.x = this.hx; } else { this.x = this.hx + o; this.y = this.hy + Math.sin(this.t * 3.1) * 3; }
    }
    draw(g, cx, cy) { this.spr(g, S.lint[((this.t * 5) | 0) % 2], cx, cy, false, 1, 1, 2); }
  }

  // --- logger: spams the room with output ---
  class Logger extends Enemy {
    constructor(L, x, y) { super(L, x, y, 14, 15); this.hp = 2; this.cd = 1 + G.hash(x, y, 4); this.open = 0; this.col = '#cfc6b4'; this.loot = 2; }
    update(dt) {
      this.tick(dt); this.cd -= dt;
      const tp = this.toPlayer();
      this.face = Math.sign(tp.dx) || 1;
      if (this.open > 0) {
        this.open -= dt;
        if (this.open <= 0.18 && !this.shot) { this.shot = true; this.L.shoot(this.cx + this.face * 8, this.y + 6, this.face * 135, 0, { kind: 'log', col: '#7dff9a', r: 3 }); G.audio.sfx('shoot'); }
      } else if (this.cd <= 0 && Math.abs(tp.dx) < 200 && Math.abs(tp.dy) < 56 && this.stun <= 0) { this.open = 0.5; this.shot = false; this.cd = 2.1; }
      this.vx *= 0.8;
      this.physics(dt);
    }
    draw(g, cx, cy) { this.spr(g, S.logger[this.open > 0 ? 1 : 0], cx, cy, false, 1, this.open > 0.3 ? 0.92 : 1); if (this.open > 0) G.light(this.cx - cx, this.y + 5 - cy, 24, '#7dff9a', 0.6, 0.25); }
  }

  // --- mimic: a deprecated package that was never really removed ---
  class Mimic extends Enemy {
    constructor(L, x, y) { super(L, x, y, 16, 14); this.hp = 3; this.awake = false; this.passive = true; this.wait = 0.5; this.col = '#c08a4e'; this.loot = 4; this.kb = 0.4; }
    wake() { if (this.awake) return; this.awake = true; this.passive = false; this.vy = -150; this.onGround = false; this.L.pop(this.cx, this.y - 8, 'DEPRECATED!', '#ffb3b3'); G.audio.sfx('warn'); }
    update(dt) {
      this.tick(dt);
      const tp = this.toPlayer();
      if (!this.awake) { if (tp.d < 46 && Math.abs(tp.dy) < 26) this.wake(); this.physics(dt); return; }
      if (this.onGround) {
        this.vx *= 0.6; this.wait -= dt;
        if (this.wait <= 0 && this.stun <= 0) { this.face = Math.sign(tp.dx) || 1; this.vx = this.face * 74; this.vy = -255; this.onGround = false; this.wait = 0.7; }
      }
      if (this.physics(dt)) { this.L.dust(this.cx, this.y + this.h, 5); this.L.shake(0.14); G.audio.sfx('thud', { vol: 0.5 }); }
    }
    onHurt() { this.wake(); }
    draw(g, cx, cy) { this.spr(g, S.mimic[!this.awake ? 0 : this.onGround ? 1 : 2], cx, cy, this.face > 0 && this.awake, 1, 1, this.awake ? 0 : 3); }
  }

  // --- noodle: spaghetti code. winds up, then goes everywhere at once ---
  class Noodle extends Enemy {
    constructor(L, x, y) { super(L, x, y, 16, 9); this.hp = 2; this.st = 'walk'; this.st_t = 0; this.col = '#f6d76b'; this.face = G.hash(x, y, 1) < 0.5 ? -1 : 1; this.loot = 2; }
    update(dt) {
      this.tick(dt); this.st_t -= dt;
      const tp = this.toPlayer();
      if (this.st === 'walk') {
        if (this.onGround) { if (this.hitWall || this.edgeAhead(this.face)) this.face = -this.face; if (this.stun <= 0) this.vx = this.face * 17; }
        if (Math.abs(tp.dy) < 22 && Math.abs(tp.dx) < 115 && this.stun <= 0 && this.onGround) { this.face = Math.sign(tp.dx) || 1; this.st = 'rev'; this.st_t = 0.5; this.vx = 0; G.audio.sfx('charge', { vol: 0.6 }); }
      } else if (this.st === 'rev') {
        this.vx = 0;
        if (this.st_t <= 0) { this.st = 'charge'; this.st_t = 0.95; }
      } else if (this.st === 'charge') {
        this.vx = this.face * 195;
        if (Math.random() < 0.5) this.L.dust(this.cx - this.face * 8, this.y + this.h, 1, -this.face);
        if (this.hitWall || this.st_t <= 0 || (this.onGround && this.edgeAhead(this.face))) { if (this.hitWall) { this.L.shake(0.15); this.L.dust(this.cx + this.face * 8, this.cy, 4); } this.st = 'tired'; this.st_t = 1; this.vx = 0; }
      } else { this.vx *= 0.8; if (this.st_t <= 0) this.st = 'walk'; }
      this.physics(dt);
    }
    draw(g, cx, cy) {
      const mad = this.st === 'rev' || this.st === 'charge';
      const img = S.noodle[(mad ? 2 : 0) + (((this.t * (mad ? 16 : 5)) | 0) % 2)];
      const jit = this.st === 'rev' ? ((this.t * 40) | 0) % 2 : 0;
      this.spr(g, img, cx + jit, cy, this.face < 0, this.st === 'tired' ? 1.1 : 1, this.st === 'tired' ? 0.85 : 1);
      if (this.st === 'tired' && ((this.t * 4) | 0) % 2) G.text(g, 'z', this.cx - cx + 6, this.y - cy - 8, '#f4ede0', { tiny: true });
    }
  }

  // --- leak: a blob of memory nobody freed. splits when popped ---
  class Slime extends Enemy {
    constructor(L, x, y, small) { super(L, x, y, small ? 8 : 14, small ? 6 : 10); this.small = small; this.hp = small ? 1 : 2; this.wait = 0.5 + G.hash(x, y, 2) * 0.6; this.col = '#58f0c8'; this.loot = small ? 1 : 0; }
    update(dt) {
      this.tick(dt);
      if (this.onGround) {
        this.vx *= 0.6; this.wait -= dt;
        if (this.wait <= 0 && this.stun <= 0) {
          const tp = this.toPlayer();
          this.face = tp.d < 130 ? Math.sign(tp.dx) || 1 : (Math.random() < 0.5 ? -1 : 1);
          if (this.edgeAhead(this.face) && tp.d > 50) this.face = -this.face;
          this.vx = this.face * (this.small ? 62 : 44); this.vy = this.small ? -175 : -150; this.onGround = false; this.wait = this.small ? 0.5 : 0.9;
        }
      }
      if (this.physics(dt)) this.land = 0.14;
      if (this.land > 0) this.land -= dt;
      if (this.hitWall) this.vx = -this.vx * 0.5;
    }
    die(how) {
      super.die(how);
      if (!this.small) for (const d of [-1, 1]) { const s = new Slime(this.L, this.x, this.y, true); s.x = this.cx - 4 + d * 4; s.y = this.y; s.vx = d * 80; s.vy = -170; s.wait = 0.5; this.L.ents.push(s); }
    }
    draw(g, cx, cy) {
      const sq = this.land > 0 ? 1.2 : this.onGround && this.wait < 0.15 ? 1.12 : !this.onGround ? 0.88 : 1;
      this.spr(g, (this.small ? S.slimeS : S.slime)[((this.t * 3) | 0) % 2], cx, cy, false, sq, 2 - sq);
      G.light(this.cx - cx, this.cy - cy, 22, '#58f0c8', 0.5, 0.16);
    }
  }

  // --- heisenbug: only moves when you are not looking ---
  class Ghost extends Enemy {
    constructor(L, x, y) { super(L, x, y - 3, 12, 13); this.hp = 2; this.shy = false; this.col = '#cfe6ff'; this.front = true; this.loot = 3; this.a = 0.9; }
    update(dt) {
      this.tick(dt);
      const p = this.L.player, tp = this.toPlayer();
      this.shy = Math.sign(tp.dx) === -p.face && tp.d < 190;
      this.face = Math.sign(tp.dx) || 1;
      if (!this.shy && tp.d < 190 && tp.d > 2 && this.stun <= 0 && !p.dead) { this.x += (tp.dx / tp.d) * 44 * dt; this.y += (tp.dy / tp.d) * 44 * dt; }
      this.vx *= 0.9; this.x += this.vx * dt;
      this.a = G.damp(this.a, this.shy ? 0.55 : 0.95, 8, dt);
    }
    draw(g, cx, cy) {
      g.globalAlpha = this.a;
      this.spr(g, S.ghost[this.shy ? 2 : ((this.t * 4) | 0) % 2], cx, cy, this.face < 0, 1, 1, Math.round(Math.sin(this.t * 3) * 2));
      g.globalAlpha = 1;
      G.light(this.cx - cx, this.cy - cy, 30, '#cfe6ff', 0.6, 0.2);
    }
  }

  // --- racer: a thread that got there first ---
  class Racer extends Enemy {
    constructor(L, x, y) { super(L, x, y, 14, 8); this.pause = 0; this.col = '#ffb347'; this.face = G.hash(x, y, 1) < 0.5 ? -1 : 1; }
    update(dt) {
      this.tick(dt);
      if (this.pause > 0) { this.pause -= dt; this.vx = 0; }
      else if (this.onGround && this.stun <= 0) {
        if (this.hitWall || this.edgeAhead(this.face)) { this.face = -this.face; this.pause = 0.4; this.vx = 0; }
        else { this.vx = this.face * 132; if (Math.random() < 0.3) this.L.dust(this.cx - this.face * 7, this.y + this.h, 1, -this.face); }
      }
      this.physics(dt);
    }
    draw(g, cx, cy) { this.spr(g, S.racer[((this.t * 14) | 0) % 2], cx, cy, this.face < 0, this.pause > 0 ? 0.9 : 1.05, this.pause > 0 ? 1.1 : 1); }
  }

  // --- hotfix drone: shoots first, opens a ticket later ---
  class Drone extends Enemy {
    constructor(L, x, y) { super(L, x, y - 6, 14, 10); this.hp = 2; this.cd = 1.5; this.aim = 0; this.col = '#8a92a8'; this.loot = 3; }
    update(dt) {
      this.tick(dt);
      const p = this.L.player, tp = this.toPlayer();
      if (tp.d < 210) {
        this.cd -= dt;
        const side = this.cx < p.x ? -1 : 1, tx = p.x + 5 + side * 66 - this.w / 2, ty = p.y - 46;
        if (this.aim <= 0 && this.stun <= 0) {
          const nx = G.damp(this.x, tx, 1.3, dt), ny = G.damp(this.y, ty, 1.3, dt);
          if (!this.L.boxHitsSolid(nx, this.y, this.w, this.h)) this.x = nx;
          if (!this.L.boxHitsSolid(this.x, ny, this.w, this.h)) this.y = ny;
        }
        if (this.aim > 0) {
          this.aim -= dt;
          if (this.aim <= 0) { const n = tp.d || 1; this.L.shoot(this.cx, this.cy + 4, (tp.dx / n) * 125, (tp.dy / n) * 125, { kind: 'orb', col: '#ff5d5d', r: 3 }); G.audio.sfx('shoot'); this.cd = 2.5; }
        } else if (this.cd <= 0) { this.aim = 0.5; G.audio.sfx('warn', { vol: 0.5 }); }
      }
      this.y += Math.sin(this.t * 4) * 0.15;
      this.x += this.vx * dt; this.vx *= 0.88;
    }
    draw(g, cx, cy) {
      this.spr(g, S.drone[(this.aim > 0 ? 2 : 0) + (((this.t * 20) | 0) % 2)], cx, cy, false, 1, 1, 3);
      G.light(this.cx - cx, this.cy + 4 - cy, this.aim > 0 ? 30 : 16, '#ff5d5d', 0.7, this.aim > 0 ? 0.4 : 0.15);
    }
  }

  // --- hazards: not alive, cannot be hurt ---
  class Pendulum extends Enemy {
    constructor(L, x, y) { super(L, x, y, 12, 12); this.ax = x + 8; this.ay = y; this.len = 54; this.noHit = true; this.stompable = false; this.dashable = false; this.ph = G.hash(x, y, 6) * 6; this.always = false; this.place(); }
    place() { const a = Math.sin(this.L.time * 1.8 + this.ph) * 1.15; this.bx = this.ax + Math.sin(a) * this.len; this.by = this.ay + Math.cos(a) * this.len; this.x = this.bx - 6; this.y = this.by - 6; }
    update() { this.place(); }
    draw(g, cx, cy) {
      const n = 9;
      for (let i = 0; i <= n; i++) { const u = i / n; g.fillStyle = i % 2 ? '#8b91a3' : '#5c6378'; g.fillRect(Math.round(G.lerp(this.ax, this.bx, u)) - cx - 1, Math.round(G.lerp(this.ay, this.by, u)) - cy - 1, 2, 2); }
      g.fillStyle = C.ink; g.fillRect(this.ax - cx - 3, this.ay - cy, 6, 3);
      g.drawImage(S.pendulum, Math.round(this.bx) - cx - 9, Math.round(this.by) - cy - 9);
      G.light(this.bx - cx, this.by - cy, 20, C.hazard, 0.4, 0.14);
    }
  }
  class Gear extends Enemy {
    constructor(L, x, y, moving) {
      super(L, x, y, 18, 18); this.x = x - 1; this.y = y - 1; this.noHit = true; this.stompable = false; this.dashable = false;
      this.a = this.x; this.b = this.x; this.ph = G.hash(x, y, 2);
      if (moving) {
        const row = L.def.map[y / T], tx = x / T;
        for (let i = tx + 1; i < row.length; i++) if (row[i] === '|') { this.b = i * T - 1; break; }
        if (this.b === this.a) for (let i = tx - 1; i >= 0; i--) if (row[i] === '|') { this.b = i * T - 1; break; }
        this.always = true;
      }
    }
    update(dt) {
      this.t += dt;
      const span = Math.abs(this.b - this.a);
      if (span > 1) { const period = (span / 58) * 2, u = 0.5 - 0.5 * Math.cos(((this.L.time / period + this.ph) % 1) * Math.PI * 2); this.x = G.lerp(this.a, this.b, u); }
      if (Math.random() < 0.06) this.L.spark(this.cx + G.rand(-8, 8), this.cy + 9, '#ffe27a', 1);
    }
    harmboxes() { return [{ x: this.x + 2, y: this.y + 2, w: 14, h: 14 }]; }
    draw(g, cx, cy) { g.drawImage(S.gear[((this.t * 16) | 0) % 6], Math.round(this.cx) - cx - 13, Math.round(this.cy) - cy - 13); }
  }
  class Dripper extends Enemy {
    constructor(L, x, y) { super(L, x, y, 4, 4); this.x = x + 6; this.y = y; this.noHit = true; this.passive = true; this.cd = G.hash(x, y, 8) * 2; this.grow = 0; }
    update(dt) {
      this.cd -= dt;
      if (this.grow > 0) {
        this.grow -= dt;
        if (this.grow <= 0) { this.L.shoot(this.x + 2, this.y + 5, 0, 20, { kind: 'drip', col: this.L.th.liq, g: 520, r: 2, cut: false, onLand: (q, L) => { L.burst(q.x, q.y - 2, 4, [L.th.liq, L.th.liqHi], 50, 300); if (Math.abs(q.x - L.player.x) < 200) G.audio.sfx('drip', { vol: 0.6 }); } }); this.cd = 1.7; }
      } else if (this.cd <= 0) this.grow = 0.55;
    }
    draw(g, cx, cy) {
      const th = this.L.th;
      g.fillStyle = th.liqLo; g.fillRect(this.x - cx - 1, this.y - cy, 6, 2);
      if (this.grow > 0) { const s = Math.ceil((1 - this.grow / 0.55) * 4); g.fillStyle = th.liq; g.fillRect(this.x - cx + 1, this.y - cy + 2, 2, s); g.fillRect(this.x - cx, this.y - cy + 1 + s, 4, 2); }
    }
  }
  class FireJet extends Enemy {
    constructor(L, x, y) { super(L, x, y, 10, 44); this.x = x + 3; this.y = y + T - 44; this.noHit = true; this.stompable = false; this.dashable = false; this.ph = G.hash(x, y, 9) * 3.2; this.on = false; this.bx = x; this.by = y; }
    update(dt) {
      this.t += dt;
      const c = (this.L.time + this.ph) % 3.2;
      const was = this.on;
      this.warn = c > 1.5 && c < 2.1; this.on = c >= 2.1;
      this.passive = !this.on;
      if (this.on && !was && Math.abs(this.cx - this.L.player.x) < 220) G.audio.sfx('dash', { vol: 0.5 });
      if (this.warn && Math.random() < 0.4) this.L.part(this.cx + G.rand(-3, 3), this.by + 12, G.rand(-10, 10), G.rand(-60, -20), 0.3, 1, '#ffd23f', 0, { glow: 1 });
      if (this.on) for (let i = 0; i < 3; i++) this.L.part(this.cx + G.rand(-4, 4), this.by + 12, G.rand(-14, 14), G.rand(-230, -150), G.rand(0.14, 0.24), 2 + (Math.random() * 3 | 0), G.pick(['#fff', '#ffd23f', '#ff7a2f', '#ff4b3e']), 0, { glow: 1 });
    }
    draw(g, cx, cy) {
      const x = this.bx - cx, y = this.by - cy;
      g.fillStyle = C.ink; g.fillRect(x + 2, y + 11, 12, 5);
      g.fillStyle = this.warn && ((this.t * 12) | 0) % 2 ? '#ffd23f' : '#5c6378'; g.fillRect(x + 3, y + 12, 10, 3);
      g.fillStyle = '#1b1226'; g.fillRect(x + 5, y + 12, 6, 1);
      if (this.on) G.light(x + 8, y - 10, 60, '#ff7a2f', 1, 0.4);
    }
  }

  const MAKE = {
    b: (L, x, y) => new Bug(L, x, y, false), a: (L, x, y) => new Bug(L, x, y, true), t: (L, x, y) => new Typo(L, x, y),
    f: (L, x, y) => new Flaky(L, x, y), l: (L, x, y) => new Lint(L, x, y, false), L: (L, x, y) => new Lint(L, x, y, true),
    g: (L, x, y) => new Logger(L, x, y), m: (L, x, y) => new Mimic(L, x, y), n: (L, x, y) => new Noodle(L, x, y),
    s: (L, x, y) => new Slime(L, x, y, false), h: (L, x, y) => new Ghost(L, x, y), r: (L, x, y) => new Racer(L, x, y),
    d: (L, x, y) => new Drone(L, x, y), p: (L, x, y) => new Pendulum(L, x, y), O: (L, x, y) => new Gear(L, x, y, false),
    Q: (L, x, y) => new Gear(L, x, y, true), i: (L, x, y) => new Dripper(L, x, y), F: (L, x, y) => new FireJet(L, x, y),
  };
  G.spawnEnemy = (ch, x, y, L) => (MAKE[ch] ? MAKE[ch](L, x, y) : null);
  G.Enemies = { Bug, Typo, Flaky, Lint, Logger, Mimic, Noodle, Slime, Ghost, Racer, Drone };
})();

